import { HorizontalDivider } from "../../../common/components/core";
import { generateTypeDisplayName } from "../ProfileManageMentView";

import { CreateNewProfileFormValues } from "./CreateNewProfileForm";

type CreateProfileConfirmationContentProps = {
    data: CreateNewProfileFormValues | undefined;
};
const CreateProfileConfirmationContent = ({
    data,
}: CreateProfileConfirmationContentProps): JSX.Element => {
    return (
        <>
            {data && (
                <div className="my-2">
                    <dl>
                        <h2 className="mb-7 rem-1">Profile Details</h2>
                        <div className="row mb-2">
                            <dt className="col-5 fw-bold">Profile Type:</dt>
                            <dd className="col-7 text-primary fw-bold high-contrast-red">
                                {generateTypeDisplayName(data.entityType)}
                            </dd>
                        </div>
                        <div className="row mb-2">
                            <dt className="col-5 fw-bold">Profile Name:</dt>
                            <dd className="col-7 text-primary fw-bold high-contrast-red">
                                {" "}
                                {data.entityName}{" "}
                            </dd>
                        </div>
                        <div className="row mb-2">
                            <dt className="col-5 fw-bold">
                                Profile Country & City:
                            </dt>
                            <dd className="col-7 text-primary fw-bold high-contrast-red">
                                {" "}
                                {data.entityCountryCity}{" "}
                            </dd>
                        </div>
                        <div className="mt-5">
                            <dt className="text-primary fw-bold high-contrast-red">IMPORTANT:</dt>
                            <dd className="fs-7">
                                Please ensure that the Profile details are correct
                                as you will not be able to change them upon
                                confirmation.
                            </dd>
                        </div>
                    </dl>
                    <HorizontalDivider className="my-3" />
                    <dl>
                        <h3 className="mb-7">Contact Person Details</h3>
                        <div className="row mb-2">
                            <dt className="col-5 fw-bold">
                                Contact Person Name:
                            </dt>
                            <dd className="col-7 fw-bold">
                                {" "}
                                {data.contactPersonName}
                            </dd>
                        </div>
                        <div className="row mb-2">
                            <dt className="col-5 fw-bold">
                                Contact Person Number:
                            </dt>
                            <dd className="col-7 fw-bold">
                                {" "}
                                {data.contactPersonNumber}
                            </dd>
                        </div>
                        <div className="row mb-2">
                            <dt className="col-5 fw-bold">
                                Contact Person Email Address:
                            </dt>
                            <dd className="col-7 fw-bold">
                                {data.contactPersonEmail}
                            </dd>
                        </div>
                    </dl>
                </div>
            )}
        </>
    );
};

export default CreateProfileConfirmationContent;
